import { get } from '@ebay/presence-ui/lib/object-helpers';
import storeEvent from '@ebay/presence-ui/lib/store-event';
import { hasCurrentCategory } from './util';

const SEL = {
    content: '.str-left-nav__content',
    itemCard: '.str-item-card',
    sectionBody: '.str-left-nav__section-body'
};
const CLS = {
    fixed: 'fixed',
    expanded: 'expanded',
    open: 'open'
};

export default class {
    onCreate(input) {
        const catModule = get(input, 'page.modules.STORE_CATEGORIES_MODULE', null);
        const categories = get(catModule, 'categories', []);
        const hasCurrentCat = hasCurrentCategory(categories);
        this.state = {
            categories,
            isOpen: hasCurrentCat,
            openClass: hasCurrentCat ? CLS.open : '',
            stickyClass: '',
            section: {
                shipTo: initShipToState(input)
            },
            a11yTitle: get(catModule, 'title.text', 'Filter by category')
        };
    }
    onMount() {
        this.root = this.getEl('str-left-nav');
        if (this.root) {
            this.currentTabIndex = 0;
            this.handleToggleLeftNav();
            this.handleStickyHeader();
            this.handleStoreTabChange();
        }
    }
    handleStoreTabChange() {
        storeEvent.tabHasChanged.listen(data => {
            this.currentTabIndex = data.tabIndex;
        });
    }
    handleToggleLeftNav() {
        storeEvent.toggleLeftNav.listen(() => {
            // If toggle button clicked while on another tab,
            // change to shopTab first, then open if not already open.
            if (this.currentTabIndex !== 0) {
                storeEvent.changeToTab.dispatch({
                    tabIndex: 0,
                    skipFocus: true
                });
                if (!this.state.isOpen) {
                    this.open();
                }
            } else if (this.state.isOpen) {
                this.close();
            } else {
                this.open();
            }
            doubleRaf(() => {
                storeEvent.toggleLeftNavDone.dispatch({ isOpen: this.state.isOpen });
            });
        });
    }
    open() {
        // Need to render before sliding open
        this.state.isOpen = true;
        doubleRaf(() => {
            this.padForGlobalFooter();
            this.state.openClass = CLS.open;
        });
    }
    close() {
        // Need to slide close before rendering
        this.state.openClass = '';
        doubleRaf(() => {
            this.state.isOpen = false;
        });
    }
    handleStickyHeader() {
        storeEvent.stickyLeftNav.listen(data => {
            // There's an issue when there's not enough content on page to
            // keep scroll position when leftNav becomes position:fixed.
            //
            // As the page is scrolled down, the leftNav will become fixed at a certain point.
            // Fixed elements are taken out of the flow. So if there's not enough content to
            // keep the scroll position, the page scrolls back up, which removes the leftNav position:fixed.
            // This causes a self-inducing loop where the leftNav becomes fixed only to become unfixed
            // because there's not enough content to keep scroll position.
            //
            // The current solution is to not position:fix the leftNav when there are no listings.
            const itemCard = document.querySelector(SEL.itemCard);
            if (data.isSticky && itemCard) {
                this.state.stickyClass = CLS.fixed;
            } else {
                this.state.stickyClass = '';
            }
        });
    }
    // The content element of the leftNav goes to the bottom of the viewport.
    // When the global footer is scrolled into view, it can mask some of the
    // content. The solve for this is to add padding-bottom to the content
    // element to bump it above the global footer so that it's visible.
    padForGlobalFooter() {
        const globalFooter = document.querySelector('.global-footer');
        if (globalFooter) {
            const extraPad = 40;
            const contentEl = this.root.querySelector(SEL.content);
            if (contentEl) {
                contentEl.style.paddingBottom = `${globalFooter.offsetHeight + extraPad }px`;
            }
        }
    }
    expandSection(sectionName) {
        const section = this.state.section[sectionName];
        if (section) {
            section.isExpanded = !section.isExpanded;
            this.setStateDirty(sectionName);
            doubleRaf(() => {
                section.expandedClass = section.isExpanded ? CLS.expanded : '';
                this.setStateDirty(sectionName);
            });
        }
    }
}

function initShipToState(input) {
    const shipTo = get(input, 'page.modules.SHIPPING_DESTINATION_MODULE.shippingToLocation', null);
    const currentZip = get(shipTo, 'minView.zipCode.label.textSpans.0.text', '');
    const isExpanded = !currentZip; // If no currentZip, then expand section body
    return {
        isExpanded: isExpanded,
        expandedClass: isExpanded ? CLS.expanded : ''
    };
}

function doubleRaf(callback) {
    requestAnimationFrame(() => requestAnimationFrame(() => {
        callback();
    }));
}
